import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export type ImportLessonResult = {
  lessonCount: number;
  exerciseCount: number;
};

export function useImportLesson() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (chapterId: string): Promise<ImportLessonResult> => {
      const { data, error } = await supabase.functions.invoke('import-lesson', {
        body: { chapterId },
      });
      if (error) throw new Error(error.message);
      return data as ImportLessonResult;
    },
    onSettled: (_data, _err, chapterId) => {
      qc.invalidateQueries({ queryKey: ['admin-chapter-detail', chapterId] });
      qc.invalidateQueries({ queryKey: ['admin-chapters'] });
    },
  });
}
